import { starRatingLabels } from './starRatingLabels';
import { EStarRating } from '../../../packages/JsonQuery';

interface IStarRatingOption {
  label: string;
  value: EStarRating;
}

export const starRatingOptions: IStarRatingOption[] = [
  { value: EStarRating.NoRating, label: starRatingLabels[EStarRating.NoRating] },
  { value: EStarRating.Star1, label: starRatingLabels[EStarRating.Star1] },
  { value: EStarRating.Star2, label: starRatingLabels[EStarRating.Star2] },
  { value: EStarRating.Star3, label: starRatingLabels[EStarRating.Star3] },
  { value: EStarRating.Star4, label: starRatingLabels[EStarRating.Star4] },
  { value: EStarRating.Star5, label: starRatingLabels[EStarRating.Star5] },
];
